import * as React from "react";
import {cx} from "emotion";
import {FontAwesomeIcon}                from "@fortawesome/react-fontawesome";
import {faChevronUp, faChevronDown}     from "@fortawesome/free-solid-svg-icons";

import "./layout.scss";

import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {provideContext1}              from "@Common/react/context";
import {Static2}                      from "@Common/react/static-2";
import {UseState}                     from "@Common/react/use-state";
import {Responsive2}                  from "@Common/ui-components/responsive-2";
import {SliderCheckbox}               from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {parseUrlQuery}                from "@Common/utils/parse-url-query";

import {ColorPicker} from "../common/color-picker/color-picker";

import {LayoutDesktopHeader} from "./desktop/header/header";
import {LiveChat}            from "./desktop/live-chat/live-chat";
import {LayoutFooter}        from "./footer/footer";
import {LayoutMobileHeader}  from "./mobile/layout-mobile-header";
import {Notifications}       from "./notifications/notifications";

export const Layout = (
    {
        children, active=undefined, className=null, fullScreen=false, emulationPlugins=undefined,
        navBlock=undefined,
        disableSuggestionsDialog=false,

        readFile = async (e) => {
            e.preventDefault()
    
            const fileReader = new FileReader()
            fileReader.onload = async (e) => {
                const upload = e.target.result
            }
            const fileUploaded = e.target.files[0]
            e.target.value = ''
        }
    }
) => cs(
    ["responsive", (_, next) => Responsive2({
        translate: (w) => w < 1024 ? "mobile" : "desktop",
        next,
    })],
    ["mobileHeader", (_, next) => LayoutMobileHeader({next})],
    ["editor", ({}, next) => next({
        value: parseUrlQuery(window.location.search)?.edit === "scheme",
    })],
    ({editor}, next) => provideContext1("editor", editor, next),
    ({responsive, mobileHeader, editor}) => (
        <div className={cx("main-content-container", {editor: editor?.value})}>
            {editor?.value && (
                ThemeEditor({})
            )}

            <div className={cx("layout-2w7", responsive, {fullScreen})}>
                {responsive === "mobile" && (
                    mobileHeader.render({navBlock})
                )}
                {responsive === "desktop" && (
                    LayoutDesktopHeader({active, disableSuggestionsDialog, emulationPlugins, navBlock})
                )}

                {Notifications()}

                <div className={cx("content", className)}>
                    {children}
                </div>

                {responsive === "desktop" && (
                    LiveChat()
                )}

                {(responsive === "desktop" || !fullScreen) && (
                    LayoutFooter({
                        navBlock,
                    })
                )}
            </div>
        </div>
    ),
);

const ThemeEditor = ({}) => cs(
    consumeContext("themeScheme"),
    ["ref", (_, next) => Static2({next})],
    ["ref2", (_, next) => Static2({next})],
    ["desktop", (_, next) => Static2({next})],
    ["mobile", (_, next) => Static2({next})],
    ["email", (_, next) => Static2({next})],

    ["editColor", ({}, next) => UseState({
        initValue: undefined,
        next,
    })],

    ({themeScheme, ref, ref2, desktop, mobile, email, editColor}) => (
        <div className="theme-editor">
            <div className="content">
                <div className="header">
                    <div className="line-item header-logo">
                        <div className="text-div">Header Logo Upload:</div>
                        <div className="remove-div">
                        {themeScheme.xpresso.headerLogo && (
                            <button
                                className="remove-button"
                                onClick={() => themeScheme.xpresso.patch({
                                    deleteHeaderLogo: true,
                                    headerLogo: ""
                                })}
                            >
                                Remove
                            </button>
                        )}
                        </div>
                        <input
                            className="hidden-input"
                            type="file"
                            xd-qa-name="Select a File"
                            xd-qa-type="file_input"
                            ref={ref.set}
                            onChange={(e) => {
                                const val = e.target?.files?.[0];
                                val && themeScheme.xpresso.patch({headerLogo: val})
                                e.target.value = ''
                            }}
                        />
                        <button
                            className="expand-button select-file"
                            onClick={() => ref.get().click()}
                        >
                            Upload
                        </button>
                    </div>
                    <div className="line-item header-logo-url">
                        Header Logo URL:&nbsp;
                        <input {...{
                            value: themeScheme.xpresso.headerLogo,
                            onChange: (e) => {
                                themeScheme.xpresso.patch({headerLogo: e.target.value})
                            },
                            className: "header-logo-input",
                        }}/>
                    </div>

                    <div className="line-item header-banner">
                        <div className="text-div">Header Banner Upload:</div>
                        <div className="remove-div">
                        {themeScheme.xpresso.headerBanner && (
                            <button
                                className="remove-button"
                                onClick={() => themeScheme.xpresso.patch({
                                    deleteHeaderBanner: true,
                                    headerBanner: ""
                                })}
                            >
                                Remove
                            </button>
                        )}
                        </div>
                        <input
                            className="hidden-input"
                            type="file"
                            xd-qa-name="Select a File"
                            xd-qa-type="file_input"
                            ref={ref2.set}
                            onChange={(e) => {
                                const val = e.target?.files?.[0];
                                val && themeScheme.xpresso.patch({headerBanner: val})
                                e.target.value = ''
                            }}
                        />
                        <button
                            className="expand-button select-file"
                            onClick={() => ref2.get().click()}
                        >
                            Upload
                        </button>
                    </div>
                    <div className="line-item header-banner-url">
                        Header Banner URL:&nbsp;
                        <input {...{
                            value: themeScheme.xpresso.headerBanner,
                            onChange: (e) => {
                                themeScheme.xpresso.patch({headerBanner: e.target.value})
                            },
                            className: "header-banner-input",
                        }}/>
                    </div>

                    {themeScheme.xpresso.headerBanner && <>
                        <div className="line-item header-color">
                            Header Color:&nbsp;
                            <button
                                className="expand-button header-color"
                                onClick={async () => editColor.value === "headerBackground" ? editColor.onChange(undefined) : editColor.onChange("headerBackground")}
                            >
                                {editColor.value === "headerBackground" ? (
                                    <FontAwesomeIcon icon={faChevronUp}/>
                                ) : (
                                    <FontAwesomeIcon icon={faChevronDown}/>
                                )}
                            </button>
                        </div>
                        <div className={cx("color-picker", {showing: editColor.value === "headerBackground"})}>
                            <ColorPicker
                                initialColor={themeScheme.xpresso.headerColor}
                                onChange={(color) => {
                                    themeScheme.xpresso.patch({headerColor: color})
                                }}
                            />
                        </div>
                    </>}
                </div>
                <div className="logo">
                    <div className="line-item header-banner">
                        <div className="text-div">APM2 Desktop Logo Upload:</div>
                        <div className="remove-div">
                        {themeScheme.xpresso.apm2DesktopLogo && (
                            <button
                                className="remove-button"
                                onClick={() => themeScheme.xpresso.patch({
                                    deleteApm2DesktopLogo: true,
                                    apm2DesktopLogo: ""
                                })}
                            >
                                Remove
                            </button>
                        )}
                        </div>
                        <input
                            className="hidden-input"
                            type="file"
                            xd-qa-name="Select a File"
                            xd-qa-type="file_input"
                            ref={desktop.set}
                            onChange={(e) => {
                                const val = e.target?.files?.[0];
                                val && themeScheme.xpresso.patch({apm2DesktopLogo: val})
                                e.target.value = ''
                            }}
                        />
                        <button
                            className="expand-button select-file"
                            onClick={() => desktop.get().click()}
                        >
                            Upload
                        </button>
                    </div>
                    <div className="line-item header-banner-url">
                        APM2 Desktop Logo URL:&nbsp;
                        <input {...{
                            value: themeScheme.xpresso.apm2DesktopLogo,
                            onChange: (e) => {
                                themeScheme.xpresso.patch({apm2DesktopLogo: e.target.value})
                            },
                            className: "apm2-desktop-input",
                        }}/>
                    </div>
                </div>
                <div className="logo">
                    <div className="line-item header-banner">
                        <div className="text-div">APM2 Mobile Logo Upload:</div>
                        <div className="remove-div">
                        {themeScheme.xpresso.apm2MobileLogo && (
                            <button
                                className="remove-button"
                                onClick={() => themeScheme.xpresso.patch({
                                    deleteApm2MobileLogo: true,
                                    apm2MobileLogo: ""
                                })}
                            >
                                Remove
                            </button>
                        )}
                        </div>
                        <input
                            className="hidden-input"
                            type="file"
                            xd-qa-name="Select a File"
                            xd-qa-type="file_input"
                            ref={mobile.set}
                            onChange={(e) => {
                                const val = e.target?.files?.[0];
                                val && themeScheme.xpresso.patch({apm2MobileLogo: val})
                                e.target.value = ''
                            }}
                        />
                        <button
                            className="expand-button select-file"
                            onClick={() => mobile.get().click()}
                        >
                            Upload
                        </button>
                    </div>
                    <div className="line-item header-banner-url">
                        APM2 Mobile Logo URL:&nbsp;
                        <input {...{
                            value: themeScheme.xpresso.apm2MobileLogo,
                            onChange: (e) => {
                                themeScheme.xpresso.patch({apm2MobileLogo: e.target.value})
                            },
                            className: "apm2-mobile-input",
                        }}/>
                    </div>
                </div>
                <div className="logo">
                    <div className="line-item header-banner">
                        <div className="text-div"> APM2 Email Logo Upload: </div>
                        <div className="remove-div">
                        {themeScheme.xpresso.apm2EmailLogo && (
                            <button
                                className="remove-button"
                                onClick={() => themeScheme.xpresso.patch({
                                    deleteApm2EmailLogo: true,
                                    apm2EmailLogo: ""
                                })}
                            >
                                Remove
                            </button>
                        )}
                        </div>
                        <input
                            className="hidden-input"
                            type="file"
                            xd-qa-name="Select a File"
                            xd-qa-type="file_input"
                            ref={email.set}
                            onChange={(e) => {
                                const val = e.target?.files?.[0];
                                val && themeScheme.xpresso.patch({apm2EmailLogo: val})
                                e.target.value = ''
                            }}
                        />
                        <button
                            className="expand-button select-file"
                            onClick={() => email.get().click()}
                        >
                            Upload
                        </button>
                    </div>
                    <div className="line-item header-banner-url">
                        APM2 Email Logo URL:&nbsp;
                        <input {...{
                            value: themeScheme.xpresso.apm2EmailLogo,
                            onChange: (e) => {
                                themeScheme.xpresso.patch({apm2EmailLogo: e.target.value})
                            },
                            className: "apm2-email-input",
                        }}/>
                    </div>
                </div>      
                <hr/>
                <div className="menu">
                    <div className="line-item menu-background">
                        Menu Background Color:&nbsp;
                        <button
                            className="expand-button menu-background"
                            onClick={async () => editColor.value === "menuBackground" ? editColor.onChange(undefined) : editColor.onChange("menuBackground")}
                        >
                            {editColor.value === "menuBackground" ? (
                                <FontAwesomeIcon icon={faChevronUp}/>
                            ) : (
                                <FontAwesomeIcon icon={faChevronDown}/>
                            )}
                        </button>
                    </div>
                    <div className={cx("color-picker", {showing: editColor.value === "menuBackground"})}>
                        <ColorPicker
                            initialColor={themeScheme.xpresso.menuBackgroundColor}
                            onChange={(color) => {
                                themeScheme.xpresso.patch({menuBackgroundColor: color})
                            }}
                        />
                    </div>
                    <div className="line-item menu-text">
                        Menu Text Color:&nbsp;
                        <button
                            className="expand-button menu-text"
                            onClick={() => editColor.onChange(editColor.value === "menuText" ? undefined : "menuText")}
                        >
                            {editColor.value === "menuText" ? (
                                <FontAwesomeIcon icon={faChevronUp}/>
                            ) : (
                                <FontAwesomeIcon icon={faChevronDown}/>
                            )}
                        </button>
                    </div>
                    <div className={cx("color-picker", {showing: editColor.value === "menuText"})}>
                        <ColorPicker {...{
                            initialColor: themeScheme.xpresso.menuTextColor,
                            onChange: (color) => {
                                themeScheme.xpresso.patch({menuTextColor: color})
                            },
                        }}/>
                    </div>
                </div>
                <hr/>
                <div className="tile">
                    <div className="line-item tile-label">
                        Tile Label Color:&nbsp;
                        <button
                            className="expand-button tile-label"
                            onClick={() => editColor.onChange(editColor.value === "tileLabel" ? undefined : "tileLabel")}
                        >
                            {editColor.value === "tileLabel" ? (
                                <FontAwesomeIcon icon={faChevronUp}/>
                            ) : (
                                <FontAwesomeIcon icon={faChevronDown}/>
                            )}
                        </button>
                    </div>
                    <div className={cx("color-picker", {showing: editColor.value === "tileLabel"})}>
                        <ColorPicker {...{
                            initialColor: themeScheme.xpresso.tileLabelColor,
                            onChange: (color) => {
                                themeScheme.xpresso.patch({tileLabelColor: color})
                            },
                        }}/>
                    </div>
                    <div className="line-item tile-text">
                        Tile Text Color:&nbsp;
                        <button
                            className="expand-button tile-text"
                            onClick={() => editColor.onChange(editColor.value === "tileText" ? undefined : "tileText")}
                        >
                            {editColor.value === "tileText" ? (
                                <FontAwesomeIcon icon={faChevronUp}/>
                            ) : (
                                <FontAwesomeIcon icon={faChevronDown}/>
                            )}
                        </button>
                    </div>
                    <div className={cx("color-picker", {showing: editColor.value === "tileText"})}>
                        <ColorPicker {...{
                            initialColor: themeScheme.xpresso.tileLabelTextColor,
                            onChange: (color) => {
                                themeScheme.xpresso.patch({tileLabelTextColor: color})
                            },
                        }}/>
                    </div>
                </div>
            </div>
            <div className="footer">

                <div className="preview-slider">
                    {SliderCheckbox({
                        value: themeScheme.xpresso.previewingPatch,
                        onChange: () => themeScheme.xpresso.previewPatch(!themeScheme.xpresso.previewingPatch)
                    })}
                    <span className="preview-text">Preview</span>
                </div>
                <button
                    className="proceed"
                    xd-qa-type="button"
                    xd-qa-name="Save"
                    disabled={!themeScheme.xpresso.previewingPatch}
                    onClick={async () => {
                        
                        await themeScheme.xpresso.save();
                        
                        window.location.reload();
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    ),
)
